import React, { useState, useEffect } from "react";
import { Column, TotalItem, Summary, HeaderFilter, FilterRow, FilterPanel } from "devextreme-react/data-grid";
import { PaginaReporte } from "../../../Componentes/Compuestos/Paginas/PaginaReporte";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";
import { Navigate } from "react-router-dom";
import { NumberBox } from "devextreme-react";

export const CON_Reporte_ClienteConDeuda = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [filterValue, setFilterValue] = useState(0);
  const { CONT_Reportes: { function_CONT_Reportes_ClientesConDeuda } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      let resultData = await function_CONT_Reportes_ClientesConDeuda();

      setData(resultData.data)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    getData();
  }, []);

  const handleFilterChange = (e) => {
    const value = Number(e.target.value);
    setFilterValue(value);
  };

  const filteredData = filterValue > 0
    ? data.filter((item) => item.ImporteDeuda > filterValue)
    : data;

  return (
    <PaginaReporte
      Titulo="CLIENTES CON DEUDA"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">
          <div className="LV-FlexContainer" style={{ gap: '10px' }}>
            <label htmlFor="filter-input" className="form-label">Deuda a partir de: ($)</label>
            <NumberBox
              id="filter-input"
              className="form-control"
              value={filterValue}
              onChange={handleFilterChange}
              width={100}
            />
          </div>
          <div className="table-responsive">
            {data.length > 0 ? (
              <LVGridCabeceraReporte
                dataSource={filteredData}
                id="gridContainer"
              >
                <HeaderFilter visible={false} />
                <FilterPanel visible={false} />
                <FilterRow visible={false} />
                <Summary>
                  <TotalItem
                    column="IdDocVenta"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

                  <TotalItem
                    column="ImporteDeuda"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="ImporteDeuda0a7"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="ImporteDeuda8a15"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="ImporteDeuda16a30"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="ImporteDeuda31a60"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="ImporteDeudaMasDe60"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />

                  <TotalItem
                    column="ImporteAnticipos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                </Summary>

                <Column caption="Cliente" alignment="Center" >
                  <Column caption="Código" dataField="IdCliente" width="70" alignment="Right" dataType="number" allowSorting={true} />
                  <Column caption="Razón Social" dataField="ABM_EEX_Clientes_RazonSocial" width="150" alignment="Left" dataType="string" allowSorting={true} />
                  <Column caption="Nombre Apellido" dataField="ABM_EEX_Clientes_Apellido" width="150" alignment="Left" dataType="string" allowSorting={true} />
                  <Column caption="C.U.I.T." dataField="CUIT" width="200" alignment="Left" dataType="string" allowSorting={true} />
                </Column>
                <Column caption="Vendedor" alignment="Center" >
                  <Column caption="Código" dataField="IdVendedor" width="70" alignment="Right" dataType="number" allowSorting={true} />
                  <Column caption="Razón Social" dataField="Vendedor" width="150" alignment="Left" dataType="string" allowSorting={true} />
                </Column>

                <Column caption="Importes" alignment="Center">
                  <Column caption="Deuda" dataField="ImporteDeuda" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="0 a 7 días" dataField="ImporteDeuda0a7" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="8 a 15 días" dataField="ImporteDeuda8a15" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="16 a 30 días" dataField="ImporteDeuda16a30" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="31 a 45 días" dataField="ImporteDeuda31a60" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="46 a 60 días" dataField="ImporteDeuda31a60" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="Más 60 días" dataField="ImporteDeudaMasDe60" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                  <Column caption="Anticipos" dataField="ImporteAnticipos" width="150" alignment="Right" dataType="number" format="currency" allowSorting={true} />
                </Column>
                <Column caption="Último Recibo" dataField="UltimoRecibo" width="100%" minWidth={300} alignment="Left" dataType="string" allowSorting={true} />

              </LVGridCabeceraReporte>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaReporte>
  );
};
